import { FormControl, Stack, Typography, TextField } from '@mui/material';
import {
  Control,
  Controller,
  FieldPathByValue,
  FieldValues,
} from 'react-hook-form';

type YoutubeImpressionsInputProps<T extends FieldValues> = {
  control: Control<T>;
  name: FieldPathByValue<T, number | null>;
};

export const YoutubeImpressionsInput = <T extends FieldValues>(
  props: YoutubeImpressionsInputProps<T>
) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      render={({ field, fieldState }) => (
        <FormControl variant="outlined" sx={{ width: '100%' }}>
          <Stack spacing={2}>
            <Typography component="h6" variant="h6">
              YouTube Measurement
            </Typography>
            <TextField
              {...field}
              value={field.value ?? ''}
              onChange={e => {
                const value =
                  e.target.value.length > 0 ? Number(e.target.value) : null;
                field.onChange(value);
              }}
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
              type="number"
              label="Impressions"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          </Stack>
        </FormControl>
      )}
    />
  );
};
